<template>
  <v-div pt-2 pb-3 font-smaller>
    Comments are not moderated before they are posted, but they can be removed
    by the site moderators if they are found to be in contravention of our
    <a :href="commentingPolicyUrl" target="_blank" rel="noopener">
      {{ COMMENTING_POLICY ? COMMENTING_POLICY.name : "Commenting Policy" }}
      <OpenInNewTabIcon />
    </a>
    - please read this policy before you post. Comments should be used for
    scholarly discussion of the content in question. You can
    <a
      :href="`/engage/${partner}/contact-information?show=faqs`"
      target="_blank"
      rel="noopener"
    >
      find more information about how to use the commenting feature here
      <OpenInNewTabIcon />
    </a>
    .
  </v-div>
</template>

<script>
import { mapState } from "vuex";

import OpenInNewTabIcon from "~/components/OpenInNewTabIcon.vue";

export default {
  name: "CommentModerationNotification",
  components: { OpenInNewTabIcon },
  computed: {
    ...mapState({
      COMMENTING_POLICY: (state) => state.theme.information.COMMENTING_POLICY,
    }),
    partner() {
      return this.$config.partner;
    },
    commentingPolicyUrl() {
      return this.COMMENTING_POLICY
        ? this.COMMENTING_POLICY.url
        : `/engage/${this.partner}/about-information?show=commenting-policy`;
    },
  },
};
</script>
